import { render, staticRenderFns } from "./ModListUserGuildLogEntryComp.vue?vue&type=template&id=5fa253ea&scoped=true&"
import script from "./ModListUserGuildLogEntryComp.vue?vue&type=script&lang=ts&"
export * from "./ModListUserGuildLogEntryComp.vue?vue&type=script&lang=ts&"
import style0 from "./ModListUserGuildLogEntryComp.vue?vue&type=style&index=0&id=5fa253ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa253ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
